  <div *ngIf="images?.length">
    <p-galleria 
      [value]="images" 
      [responsiveOptions]="responsiveOptions" 
      [containerStyle]="{ 'max-width': '640px' }"
      [visible]="displayImageDialog" 
      [numVisible]="9" 
      [circular]="true" 
      (visibleChange)="visibleChange($event)"
      [fullScreen]="true" 
      [showItemNavigators]="true">
        <ng-template pTemplate="item" let-item>
          <img [src]="item.previewImageSrc"  alt="sorting" style="width: 100%; display: block;" />
        </ng-template>
        <ng-template pTemplate="thumbnail" let-item>
            <div class="grid grid-nogutter justify-content-center">
              <img [src]="item.thumbnailImageSrc" alt="sorting-thumbnail" style="display: block;" />
            </div>
        </ng-template>
    </p-galleria>
  </div>